import React from 'react';

import Button from 'common/components/Button';
import propTypes from 'prop-types';
import accountPropTypes from 'apps/account/propTypes';

export default class CommitmentUpsellBanner extends React.Component {
  static propTypes = {
    handleAddToCartClick: propTypes.func.isRequired,
    isMembershipOrder: propTypes.bool.isRequired,
    lineItems: propTypes.array,
    lineItemsContainOfferingId: propTypes.bool.isRequired,
    userIsSubscribed: propTypes.bool.isRequired,
    evergreenOffering: accountPropTypes.VariantOffering,
  };

  renderAddToCartButton() {
    const { activeButtonText, handleAddToCartClick } = this.props;

    return (
      <Button
        className="CommitmentUpsellBanner__button button--vivid button--small"
        onClick={() => {
          handleAddToCartClick();
        }}
      >
        {activeButtonText}
      </Button>
    );
  }

  showingCommitmentUpsellBanner() {
    const {
      isMembershipOrder,
      userIsSubscribed,
      lineItemsContainOfferingId,
    } = this.props;

    return (
      // Only display the banner if we haven't already
      // used the offer (lineItemsContainOfferingId) *and*
      // we are planning on subscribing for the first time
      // (isMembershipOrder && !userIsSubscribed)
      !lineItemsContainOfferingId && (isMembershipOrder && !userIsSubscribed)
    );
  }

  render() {
    const {
      titleText,
      descriptionText,
      variantImageUrl,
      backgroundImageUrl,
    } = this.props;

    if (this.showingCommitmentUpsellBanner()) {
      return (
        <div
          className="CommitmentUpsellBanner white"
          style={{ backgroundImage: `url(${backgroundImageUrl})` }}
        >
          <div className="CommitmentUpsellBanner__text">
            <h3 className="no-margin white">{titleText}</h3>
            <span className="CommitmentUpsellBanner__description">
              {descriptionText}
            </span>

            <div className="CommitmentUpsellBanner__cta">
              {this.renderAddToCartButton()}
            </div>
          </div>

          <img
            className="CommitmentUpsellBanner__image"
            src={`${variantImageUrl}?w=64`}
          />
        </div>
      );
    }

    return null;
  }
}
